<template>
  <div>
    <div class='form-group'>
      <label for="prize"><i class="fa-solid fa-euro-sign"></i> 
        {{__('forms.personKPIDiscretionaryPrize.value')}}
      </label>
      <input type="number" class="form-control" id="prize" v-model.number="importValue" step='0.01'
        name='personKPIDiscretionaryPrize[value]'>
    </div>
    <div>
      {{__('forms.personKPIDiscretionaryPrize.new_value_diff')}}:&nbsp;
      <strong>{{ importValue }} €</strong>&nbsp;
      <span :style="{ color: diffValue < 0 ? 'red' : 'green' }">({{ diffValueFormatted }} €)</span>
    </div>

    <div class="form-group">
      <label for="note"><i class="fa-solid fa-comment"></i> {{__('forms.personKPIDiscretionaryPrize.note')}}</label>
      <textarea 
        name='personKPIDiscretionaryPrize[note]' 
        class="form-control" id="note" 
        rows="2" 
        v-model="param_note" 
        maxlength="500"
      ></textarea>
    </div>
    <div class="d-flex justify-content-between">
      <div :class="{ 'text-danger font-weight-bold': countNoteChars >= 500 }"> {{ countNoteChars }} / 500 </div>
    </div>
  </div>
</template>

<script>

export default {

  data() {
    return {

      importValue: 0,
      param_note : '',
    }
  },
  computed: {
    countNoteChars(){
      return this.param_note.length;
    },
    diffValue() {

      let diff = Number(this.importValue) - Number(this.initial_value);
      return diff;
    },
    diffValueFormatted() {
      const sign = this.diffValue > 0 ? '+' : (this.diffValue < 0 ? '-' : '');
      const formattedValue = new Intl.NumberFormat('it-IT', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(Math.abs(this.diffValue));

      return sign + formattedValue;
    },
  },
  methods: {

  },
  mounted() {
    this.importValue = this.initial_value;
    this.param_note = this.note;
  },
  props: {
    initial_value: {
      type: Number,
      required: true
    },
    note: {
      type: String,
      required: false
    },
  }

}
</script>